<template>
    <div class="version">
        <div class="link">
            <div v-for="item in getRouter">
                <router-link v-if="!item.link" :to="item.to">
                    {{item.name}}
                </router-link>
                <a v-else :href="item.link">{{item.name}}</a>
            </div>

        </div>
        <div class="info">
            <p>
                <span class="dizhi"><img src="//admins.checkpass.net/sites/all/themes/Alliance_admin_theme/images/sm-logo.png" width="20px" height="20px" style="width: 10px;height:10px;vertical-align: middle;margin-bottom:5px;padding-right: 0;margin-top: 2px" alt="Paper联盟小LOGO">
                CopyRight ~2020 © Paper联盟商家业务支撑平台(www.checkpass.net). All Rights Reserved.<a style="color: white" href="http://beian.miit.gov.cn">湘ICP备13006151号-1</a>
            </span></p>
<!--            <p>湘IPC备XXX号-1 All Rights Reserved</p>-->
            <img src="~assets/images/home/ver1.png">
            <img src="~assets/images/home/ver2.png">
            <img src="~assets/images/home/ver3.png">
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        data() {
            return {
                router:[
                    {page:'Home',to:'/',name:'首页'},
                    {page:'Product',to:'/product',name:'产品介绍'},
                    // {page:'JoinCase',to:'/joincase',name:'加盟案例'},
                    {page:'Serve',to:'',name:'服务市场',link:'../market'},
                    {page:'Industry',to:'/industry',name:'行业介绍'},
                    {page:'About',to:'/about',name:'关于联盟'},
                    {page:'Contact',to:'/contact',name:'联系我们'}
                ],
                route:'',
                currentRouter:[]
            }
        },
        mounted() {
            this.route = this.$route.name
            let arr = this.router.filter((val)=>{
                return val.page!=this.route
            })
        },
        computed: {
            getRouter() {
                return  this.router.filter((val)=>{
                    return val.page!=this.route
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .version {
        background: #252525;
        color: #bababa;
        .link {
            box-shadow: 0 0 1px #bababa;
            padding: 55px 35px 20px;
            font-size: 20px;
            display: flex;
            a {
                color: #bababa;
                text-decoration: none;
                margin-right: 40px;
                font-size: 20px;
            }
        }
        .info {
            padding: 20px 35px 35px;
            font-size: 20px;
            img {
                height: 28px;
                padding-right: 35px;
                margin-top: 20px;
            }
        }
    }
</style>